import React from 'react';
import { DateTime } from 'luxon';
import DateTimeCellComponent from './datetime-cell';

class DateShortCellComponent extends React.Component {

  render() {
    return <DateTimeCellComponent {...this.props} format={DateTime.DATE_SHORT} />;
  }

}

export default DateShortCellComponent;


// WEBPACK FOOTER //
// ./src/views/common/date-short-cell.js